var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "#ffffff",
    className: "orderSummary-module--lockIcon--EdN2S",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8803489,15.9999952 C13.708472,15.9999952 14.3803454,15.3281218 14.3803454,14.4999988 L14.3803454,8.50001311 C14.3803454,7.67189009 13.708472,7.00001669 12.8803489,7.00001669 L12.1303507,7.00001669 L12.1303507,4.75002205 C12.1303507,2.1312844 9.99909969,3.33786011e-05 7.38036204,3.33786011e-05 C4.76162439,3.33786011e-05 2.63037336,2.1312844 2.63037336,4.75002205 L2.63037336,7.00001669 L1.88037873,7.00001669 C1.05225213,7.00001669 0.380378729,7.67189009 0.380378729,8.50001311 L0.380378729,14.4999988 C0.380378729,15.3281218 1.05225213,15.9999952 1.88037873,15.9999952 L12.8803489,15.9999952 Z M9.63035668,7.00001669 L5.1303674,7.00001669 L5.1303674,4.75002205 C5.1303674,3.50939391 6.13973389,2.50002742 7.38036204,2.50002742 C8.62099019,2.50002742 9.63035668,3.50939391 9.63035668,4.75002205 L9.63035668,7.00001669 Z",
    id: "l"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d3de5002a0be5ca034d1df269f1c1cbf.svg";
export { ForwardRef as ReactComponent };